/* eslint-disable max-len */
import React from 'react';
import './Hero.css'

export const Hero = () => {
  return (
    <div className="hero">
      <h1>Becoming a <br /> fit parent</h1>
      <p>Say Goodbye to Excuses and Hello to Results with <br /> Our Online Fitness Program for Busy Parents.</p>
      <button type="submit">Start trial</button>
    </div>
  );
}
